<template>
  <div>
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <br />
      <div>
        <center>Input Code Referal:</center>
      </div>
      <br />
      <div class="ma-auto position-relative" style="max-width: 300px">
        <v-otp-input
          ref="form"
          v-model="otp"
          :disabled="loading"
          @finish="onFinish"
        ></v-otp-input>
        <v-overlay absolute :value="loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
      </div>

      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2000">
        {{ text }}
      </v-snackbar>

      <br />
      <br />

      <v-row align="center" justify="center">
        <v-overlay color="White" :absolute="absolute" :value="overlay">
          <div class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-overlay>
      </v-row>

      <div class="d-flex flex-column justify-space-between align-center">
        <v-img
          style="display: none"
          :height="100"
          :width="100"
          src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
        ></v-img>
      </div>

      <v-list-item v-for="(item, i) in items" :key="i">
        <v-list-item-icon>
          <v-icon v-text="item.icon" color="#1b5e20"></v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item-content>

        <RockerSwitch
          ref="switchResponse"
          :size="0.9"
          style="width: 100px"
          :value="item.switch1"
          @change="(isOn) => (currentValue = isOn)(onChange(item))"
          v-if="item.id == 1 && item.disabled == 1"
        />
        <v-btn
          stacked
          variant="outlined"
          v-if="item.id == 2 && item.monitoring != null && item.disabled == 1"
          style="width: 100px"
        >
          view
        </v-btn>
        <v-btn
          style="width: 100px"
          stacked
          variant="outlined"
          v-if="
            item.id != 1 && item.id != 2 && item.monitoring != null && item.disabled == 1
          "
          @click="onView(item)"
        >
          {{ item.monitoring }}
        </v-btn>
      </v-list-item>

      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <center>Your IoT api key</center>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list-item v-for="(api, i) in apiKey" :key="i">
              <v-list-item-content v-if="api.disabled == 1">
                <span v-if="api.iot_token">Api key:</span>
                <v-list-item-title v-text="api.iot_token"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-content v-else>
                <span v-if="api.iot_token">Api key:</span>
                <v-list-item-title></v-list-item-title>
              </v-list-item-content>

              <v-list-item-icon>
                <v-btn style="width: 100px" stacked variant="outlined"
                  ><v-icon v-if="api.iot_token" v-text="api.icon" color="blue"></v-icon
                ></v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <br />
      <template>
        <v-dialog v-model="dialogView" persistent max-width="1000" id="dialogView">
          <v-responsive class="overflow-y-auto" max-height="calc(90vh - 300px)">
            <v-card>
              <v-btn
                icon
                dark
                rounded
                @click="dialogView = false"
                color="#1B5E20"
                elevation="0"
                large
                class="black--text"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <LineChartGenerator
                class="mx-auto hidden-sm-and-down"
                :chart-options="chartOptions"
                :chart-data="chartData"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
              <LineChartGenerator
                class="mx-auto hidden-sm-and-up"
                :chart-options="chartOptions"
                :chart-data="chartDataApp"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
            </v-card>
          </v-responsive>
        </v-dialog>
      </template>
    </v-card>
  </div>
</template>

<script>
// Import package
import RockerSwitch from "vue-rocker-switch";
// Import styles
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import { mapGetters, mapActions } from "vuex";
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  props: {
    isOn: Boolean,
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    items: [],
    apiKey: [],
    model: [0],
    dialogConfirm: false,
    absolute: true,
    overlay: false,

    loading: false,
    snackbar: false,
    snackbarColor: "default",
    otp: "",
    text: "",
    currentValue: false,
    dialogView: false,
    chartData: {
      labels: [],
      datasets: [
        {
          label: "Value / Hour",
          backgroundColor: "blue",
          data: [],
        },
      ],
    },
    chartDataApp: {
      labels: [],
      datasets: [
        {
          label: "Value / Hour",
          backgroundColor: "blue",
          data: [],
        },
      ],
    },
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  components: {
    RockerSwitch,
    LineChartGenerator,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  mounted() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.api_token,
      },
    };
    let url = "/service_iot";
    // url = url + '?page='+this.page
    url = encodeURI(url);
    this.axios
      .get(url, config)
      .then((response) => {
        let { data } = response.data;
        this.items = data;
        this.clear();
        this.getApiKeyByUserId();
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });
  },

  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
    }),
    onChange(event) {
      this.overlay = true;
      var data = event;
      let formData = new FormData();
      formData.set("id", data.id);
      formData.set("switch1", this.currentValue);
      formData.set("icon", data.icon);
      formData.set("text", data.text);
      formData.set("iot_id", data.iot_id);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };

      this.axios
        .post("/action_iot", formData, config)
        .then((response) => {
          let { data } = response;
          this.setAuth(data.data);

          if (data.response_code == "201") {
            if (this.currentValue) {
              this.currentValue = false;
            } else {
              this.currentValue = true;
            }
            this.setAlert({
              status: true,
              text: data.message,
              color: "warning",
            });
            location.reload();
          } else {
            this.setAlert({
              status: true,
              text: data.message,
              color: "success",
            });
          }
          this.$refs.switchResponse.$forceUpdate();
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          let { data } = error;
          this.setAlert({
            status: true,
            text: data.message,
            color: "error",
          });
          location.reload();
        });
    },

    onFinish(rsp) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.snackbarColor = rsp === this.expectedOtp ? "success" : "warning";
        this.text = `Processed OTP with "${rsp}" (${this.snackbarColor})`;
        this.snackbar = true;
        this.resetNow();
      }, 3500);
      let formData = new FormData();
      formData.set("referal_code", rsp);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };

      this.axios
        .post("/referal_code", formData, config)
        .then((response) => {
          let { data } = response;
          this.setAuth(data.data);
          this.setAlert({
            status: true,
            text: data.message,
            color: "success",
          });

          this.overlay = false;

          this.otp = "";
        })
        .catch((error) => {
          this.overlay = false;
          let { data } = error;
          this.setAlert({
            status: true,
            text: data.message,
            color: "error",
          });
        });
    },
    resetNow() {
      location.reload();
      this.otp = "";
    },

    getApiKeyByUserId() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };

      let address = "/api_key_iot";
      //address = address + '?page='+this.page
      address = encodeURI(address);
      this.axios
        .get(address, config)
        .then((response) => {
          let { data } = response.data;
          this.apiKey = data;
          this.clear();
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    clear() {
      this.$refs.form.$forceUpdate();
    },
    onView(item) {
      this.chartDataApp.datasets[0].data = [];
      this.chartDataApp.labels = [];
      this.chartData.datasets[0].data = [];
      this.chartData.labels = [];
      this.id = item.id;
      this.iot_token = item.iot_token;
      this.dialogView = true;
      let formData = new FormData();
      formData.set("id", this.id);
      formData.set("iot_token", this.iot_token);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/monitoring_iots_graph", formData, config)
        .then((response) => {
          let { data } = response.data;
          for (var i in data) {
            this.chartData.datasets[0].data.push(data[i].value);
            this.chartData.labels.push(data[i].updated_at);
            this.chartDataApp.datasets[0].data.push(data[i].value);
            this.chartDataApp.labels.push("");
          }
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.position-relative {
  position: relative;
}
</style>
